import React, { useState, useEffect } from "react";
import { useRef } from "react";
import { NavLink } from "react-router-dom";
import { Dialog } from "primereact/dialog";
import {
  FcFilingCabinet,
  FcInspection,
  FcNeutralTrading,
  FcNews,
  FcKindle,
  FcApproval,
  FcIdea
} from "react-icons/fc";
import { RxDoubleArrowRight, RxDoubleArrowLeft } from "react-icons/rx";
import TranslationFile from "../15-Translation/locale/Translation_apps.json";
import { AnimatePresence, motion } from "framer-motion";
import SidebarMenu from "./MainSideBarMenu";
import { useSelector } from "react-redux";
import TickIcon from "../../Assests/tickIcon.png";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { useHistory } from "react-router-dom";
import galaxy from "../../Assests/galaxy.png";
import { InputSwitch } from "primereact/inputswitch";
import axios from "axios";
import Joyride from "react-joyride";
import Cookies from "js-cookie";
import report from "../../Assests/Icons/report.png";
import money from "../../Assests/Icons/money.png";
import user from "../../Assests/Icons/user.png";
import logOut from "../../Assests/Icons/logout.png";
import annual from "../../Assests/Icons/annual.png";
import plus from "../../Assests/Icons/plus.png";
import ink2 from "../../Assests/Icons/ink2.png";
import "./MainSideBar.css";
import { use } from "react";
import { setUserSessionAuthKey } from "../../Component/commonUtils";
import config from "../../Configuration/Config";
let steps = [
  {
    content: "Switch on the Guided tour to explore the app",
    styles: {
      options: {
        width: 300
      }
    },
    target: ".tourguide_toogle_btn",
    title: "Explore the app",
    disableBeacon: true
  }
];

let userSelectedLanguage;
let uuid;
let possibleNavigationPagesList = ["My Dashboard", "Company Information"];
let localData = localStorage.getItem("rebelSkoolUser");
let localObject = "";
if (localData != "undefined") {
  localObject = JSON.parse(localData);
}

let showInfoToast = false;
const Sidebar = ({
  children,
  sideBarStatus,
  switchValue,
  navigateTo,
  localData,
  sideBarCallback
}) => {
  const history = useHistory();
  const toast = useRef(null);
  const [position, setPosition] = useState("center");
  const [selectedSideMenu, setSelectedSideMenu] = useState("");
  const [isInDashboardPage, setInDashboardPage] = useState(false);
  const toastBC = useRef(null);
  const [incomeButtonVisible, setIncomeButtonVisible] = useState(false);
  const sessionDetailsReducer = useSelector((state) => state.sessionDetails);
  const activeSideBarReducer = useSelector(
    (state) => state.activeSideBar.activeSideBar.values
  );

  const [showAdmin, setShowAdmin] = useState(false);
  let sessionUUIDFromLS = localStorage.getItem("sessionUUID");
  uuid = sessionDetailsReducer["sessionDetails"]["values"]
    ? sessionDetailsReducer["sessionDetails"]["values"].uuid
    : sessionUUIDFromLS;
  const annualReport = "/annualreport/";

  const userGUID =
    localObject && localObject.userGUID ? localObject.userGUID : uuid;

  const mainDashboard = "/" + userGUID + "/mainDashboard";
  const myProfile = "/" + userGUID + "/MyProfile";
  const admin = "/" + userGUID + "/admin";
  const annualReportCreate = "/" + "annualreport/" + userGUID + "/companyInfo";
  const incomeDeclarationReport =
    "/income-declaration-2/" + userGUID + "/CompanyInfo";
  userSelectedLanguage = localStorage.getItem("selectedLanguage");
  let consentValue = Cookies.get("RBLCookieConsent");
  let tourGuideResult = JSON.parse(localStorage.getItem("TourGuide")) || false;
  const [inputCheck, setInputCheck] = useState(tourGuideResult);
  const [openDialog, setOpenDialog] = useState(false);
  const [showButton, setShowButton] = useState(false);

  const routes = [
    {
      menuName: "Annual Report",
      name: (
        <div
          style={{
            marginLeft: "30px",
            marginBottom: "10px"
          }}
        >
          <Button
            className="Report_button "
            iconPos="right"
            icon=" pi pi-angle-down"
            label={TranslationFile.sidebarNewReport[userSelectedLanguage]}
          />
        </div>
      )
    },
    {
      swName: "Årsredovisning",
      name: "Annual Report",

      icon: <img src={annual} width="30px"></img>,
      path: mainDashboard
    },
    {
      swName: "Inkomstdeklaration 2",
      name: "Income Declaration 2",
      icon: <img src={ink2} width="30px"></img>,
      path: mainDashboard
    },

    {
      swName: "Konto / Beställningar",
      name: "Profile / Packages",
      icon: <img src={user} width="30px"></img>,
      path: myProfile
    },
    {
      swName: "Hantera användare",
      name: "Manage Company Users",
      icon: <FcNeutralTrading className="icon" />,
      path: admin
    },
    {
      swName: "Logga ut",
      name: "Sign Out",
      icon: <img src={logOut} width="30px"></img>,
      path: mainDashboard
    },
    {
      name: (
        <div className="create_report_button_div">
          <button class="create_report_button">
            <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
              <img
                src={plus}
                alt="Plus"
                style={{ width: "20px", height: "20px" }}
              ></img>

              {TranslationFile.AnnualReport[userSelectedLanguage]}
            </div>
          </button>
        </div>
      ),
      path: annualReportCreate
    },
    {
      menuName: "Income Declaration 2",
      name: (
        <div className="create_report_button_div">
          <button class="create_report_button">
            <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
              <img
                src={plus}
                alt="Plus"
                style={{ width: "20px", height: "20px" }}
              ></img>
              {TranslationFile.IncomeDeclaration[userSelectedLanguage]}
            </div>
          </button>
        </div>
      ),
      path: incomeDeclarationReport
    }
  ];
  const [isOpen, setIsOpen] = useState(true);
  const [showRun, setShowRun] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
    sideBarStatus(!isOpen);
  };

  let possibleAccessablePagesListLSString = localStorage.getItem(
    "possibleAccessablePages"
  );
  let sideBarReducerValues = [];
  if (null != possibleAccessablePagesListLSString)
    sideBarReducerValues = JSON.parse(possibleAccessablePagesListLSString);
  let splittedUrl = window.location.href.split("/");
  let currentReportGUIDFromUrl = splittedUrl[splittedUrl.length - 2];
  let currentPageNameFromUrl = splittedUrl[splittedUrl.length - 1];

  // const tourGuideFunc = (e) => {
  //     setInputCheck(e.value);
  //     localStorage.setItem("TourGuide", e.value);
  //     tourStatus(e.value);
  // };

  const checkingOverlayLS = () => {
    let getOverlayFromLS = localStorage.getItem("guidedTourCount");
    if (getOverlayFromLS != undefined && getOverlayFromLS != null) {
      //more than one time
      if (getOverlayFromLS > 0) {
        setShowRun(false);
        getOverlayFromLS = Number(getOverlayFromLS) + 1;
        localStorage.setItem("guidedTourCount", getOverlayFromLS);
      }
    } else {
      //first time

      setShowRun(true);
      localStorage.setItem("guidedTourCount", 1);
    }
  };

  const showAnimation = {
    hidden: {
      width: 0,
      opacity: 0
    },
    show: {
      opacity: 1,
      width: "auto"
    }
  };
  const newReport = () => {};

  const show = (position) => {
    setPosition(position);

    if (position == "top") {
      setShowButton(true);
      let possibleNavigationPagesList = ["My Dashboard"];

      possibleNavigationPagesList = [...new Set(possibleNavigationPagesList)];
      let possibleNavigationPagesListString = JSON.stringify(
        possibleNavigationPagesList
      );
      localStorage.setItem(
        "possibleAccessablePages",
        possibleNavigationPagesListString
      );
    }
  };

  const callback = (value) => {
    // sideBarCallback(value);

    navigateTo(value);
  };

  const openAnnualReportLink = () => {
    localStorage.setItem("navigateTo", "companyInformation");
    localStorage.setItem("navigateToGUID", "");
    localStorage.setItem("navigatedCompanyName", "");
    localStorage.setItem("possibleAccessablePages", "");
    localStorage.setItem("appType", "Annual Report");
    history.push("/annualreport");
    window.location.reload(false);
    window.target = "_blank";
  };

  const openIncomeDeclarationLink = async () => {
    try {
      localStorage.setItem("sruNavigateTo", "companyInfo");
      localStorage.setItem("navigateToGUID", "");
      localStorage.setItem("navigatedCompanyName", "");
      localStorage.setItem(
        "possibleAccessablePages",
        JSON.stringify(["My Dashboard"])
      );
      localStorage.setItem("appType", "Income Declaration");

      const response = await axios.get("/cms/generateUUID");

      const newReportGUID = response.data;

      console.log("UUID:", newReportGUID);

      window.location.href = `/income-declaration-2/${newReportGUID}/companyInfo`;
      window.target = "_blank";
    } catch (error) {
      console.error("Error generating UUID:", error);
    }
  };

  const sideMenuOnClick = (event, selectedSideMenuName) => {
    if (children == "Annual Report" || children == "Income Declaration 2") {
      //If the selectedSideMenuName is Annual Report
      //  Then we have to call back and give the value from child to parent
      if (
        selectedSideMenuName == "Annual Report" ||
        selectedSideMenuName == "Income Declaration 2"
        // || selectedSideMenuName == "Profile / Packages"
      ) {
        callback(selectedSideMenuName);
      }
      //Import sidebar in Myprofile and call
      //If the selectedSideMenuName is my profile => go to my profile page

      if (selectedSideMenuName == "Profile / Packages") {
        history.push(myProfile);
      }
      if (selectedSideMenuName == "Manage Company Users") {
        history.push(admin);
      }
    }
    // -------------------------
    if (
      (children === "Profile / Packages" ||
        children == "Manage Company Users") &&
      (selectedSideMenuName === "Annual Report" ||
        selectedSideMenuName === "Income Declaration 2")
    ) {
      const appType =
        selectedSideMenuName === "Annual Report"
          ? "Annual Report"
          : "Income Declaration";

      localStorage.setItem("appType", appType);
      history.push(mainDashboard);
      // callback(selectedSideMenuName);
    }
    // -------------------------
    if (selectedSideMenuName == "Manage Company Users") {
      history.push(admin);
    }
    // -------------------------
    if (selectedSideMenuName == "Profile / Packages") {
      history.push(myProfile);
    }
    // -------------------------

    //If the selectedSideMenuName is SignOut => set the localstorage rbluser to null and go to home page
    //Admin should only view for the accounting company and the functionality is same as myprofile

    if (selectedSideMenuName === "Sign Out") {
      setOpenDialog(true);
    }

    localStorage.setItem("navigateToGUID", "");
    let possibleAccessablePagesListLS = localStorage.getItem(
      "possibleAccessablePages"
    );

    let possibleAccessablePagesListLSArray =
      possibleAccessablePagesListLS &&
      JSON.parse(possibleAccessablePagesListLS);

    callback(false);
    if (
      null == possibleAccessablePagesListLSArray ||
      (null != possibleAccessablePagesListLSArray &&
        !possibleAccessablePagesListLSArray.includes(selectedSideMenuName))
    ) {
      if (!showInfoToast) {
        showInfoToast = true;
        callback(true);
        showInfoToast = false;
      }

      event.preventDefault();
    }
    {
      if (!showInfoToast) {
        const button = document.evaluate(
          '//*[@class="p-button p-component year-btn-save"]',
          document,
          null,
          XPathResult.FIRST_ORDERED_NODE_TYPE,
          null
        ).singleNodeValue;

        if (button) {
          button.click();
        }

        showInfoToast = true;

        setTimeout(() => {
          showInfoToast = false;
        }, 2000);
      }
      event.preventDefault();
    }
    setSelectedSideMenu(selectedSideMenuName);
  };

  const confirmLogout = () => {
    localStorage.setItem("rebelSkoolUser", null);
    history.push("/");
    window.location.reload();
  };

  const dialogFooter = (
    <div>
      <Button
        label={TranslationFile.noButtonLabel[userSelectedLanguage]}
        className="p-button-secondary"
        onClick={() => setOpenDialog(false)}
      />
      <Button
        label={TranslationFile.yesButtonLabel[userSelectedLanguage]}
        className="p-button-danger"
        onClick={confirmLogout}
      />
    </div>
  );

  useEffect(() => {
    console.log("First useEffect - checking screen size for sidebar");
    const mediaQuery = window.matchMedia("(max-width: 992px)");

    const handleResize = (e) => {
      if (e.matches) {
        // Screen is <= 992px
        setIsOpen(false); // auto close sidebar
      } else {
        setIsOpen(true); // auto open on desktop
      }
    };

    handleResize(mediaQuery); // run once on load
    mediaQuery.addEventListener("change", handleResize);

    return () => {
      mediaQuery.removeEventListener("change", handleResize);
    };
  }, []);

  useEffect(() => {
    if (
      localObject.isAccountingCompany === false ||
      localObject.userRole === "User"
    ) {
      setShowAdmin(false);
    } else {
      setShowAdmin(true);
    }
  }, [localObject]);
  useEffect(() => {
    const axiosConfig = setUserSessionAuthKey();

    if (axiosConfig) {
      axios
        .get("/annualReportRepresentative/getSkatteverketUIConfig", axiosConfig)
        .then((response) => {
          const payload = response.data.values ?? response.data;

          const environmentMap = {
            TEST: "testEnvironment",
            LOCAL: "localEnvironment",
            LIVE: "liveEnvironment"
          };

          const environment =
            environmentMap[(payload?.mode || "").toUpperCase()];

          const incomeVisible =
            payload?.[environment]?.isShowSkatterverketButtonVisible ?? false;

          setIncomeButtonVisible(incomeVisible);

          console.log("Mode:", payload?.mode);
          console.log("Skatterverket configuration response:", incomeVisible);
        })
        .catch((error) => {
          toast.current.show({
            severity: "error",
            summary: TranslationFile.error[userSelectedLanguage],
            detail: error.message,
            life: 3000
          });
        });
    }
  }, []);
  return (
    <div>
      <Toast ref={toast} className="Common-MainsideBarNotAccessableToast" />
      <Joyride
        continuous
        run={showRun}
        disableBeacon={true}
        showProgress={false}
        showSkipButton
        steps={steps}
        scrollToFirstStep
        scrollToSteps={true}
        disableScrolling={true}
        scrollOffset={100}
        locale={{
          next: TranslationFile.nextBtn[userSelectedLanguage], // Translated "Next" to "Nästa"
          back: TranslationFile.backText[userSelectedLanguage], // Translated "Back" to "Tillbaka"
          skip: TranslationFile.skipText[userSelectedLanguage], // Translated "Skip" to "Skippa"
          last: "OK", // Translated "Last" to "Sista"
          close: "Close" // Keep "Close" as is (or translate it if needed)
        }}
        styles={{
          options: {
            zIndex: consentValue == undefined ? 20 : consentValue && 10000
          }
        }}
      />
      <div
        className={
          isOpen
            ? "Common-main-container-sidebarOpenClass"
            : "Common-main-container-sidebarCloseClass"
        }
      >
        <motion.div
          animate={{
            width: isOpen ? "250px" : "50px"
          }}
          className={
            switchValue ? "Common-MainsidebarExtent" : `Common-Mainsidebar `
          }
        >
          <div className="Common-MainSidebar_top_section">
            <AnimatePresence>
              {isOpen && (
                <p className="subtext-annual-report">
                  {/* Main Dashboard */}
                  {/* {TranslationFile.sidebarText1[userSelectedLanguage]} */}
                </p>
              )}
            </AnimatePresence>

            <div className="bars">
              {isOpen == true ? (
                <RxDoubleArrowLeft className="icon" onClick={toggle} />
              ) : (
                <RxDoubleArrowRight className="icon" onClick={toggle} />
              )}
            </div>
          </div>

          <section className="routes">
            {routes[0].subRoutes ? (
              <SidebarMenu
                setIsOpen={setIsOpen}
                route={routes}
                showAnimation={showAnimation}
                isOpen={isOpen}
              />
            ) : (
              <div
                className="link"
                onClick={() => setShowButton(!showButton)}
                style={{ cursor: "pointer" }}
              >
                <div className="icon" style={{ marginRight: "-11px" }}>
                  {routes[0].icon}
                </div>
                <div className="menu-names-link">
                  {isOpen && <div>{routes[0].name}</div>}
                </div>
              </div>
            )}
            {showButton &&
              (routes[6].subRoutes ? (
                <SidebarMenu
                  setIsOpen={setIsOpen}
                  route={routes}
                  showAnimation={showAnimation}
                  isOpen={isOpen}
                />
              ) : (
                <div
                  className={
                    children ==
                    // "Annual Report" ? "sidebarActive"
                    "commonLink"
                  }
                  id="new_report_div"
                  onClick={(e) => {
                    e.preventDefault();
                    openAnnualReportLink();
                  }}
                >
                  <div className="icon">{routes[6].icon}</div>

                  <div className="menu-names-link">
                    {isOpen && <div>{routes[6].name}</div>}
                  </div>
                </div>
              ))}
            {showButton && (
              <>
                {incomeButtonVisible &&
                  (routes[7].subRoutes ? (
                    <SidebarMenu
                      setIsOpen={setIsOpen}
                      route={routes}
                      showAnimation={showAnimation}
                      isOpen={isOpen}
                    />
                  ) : (
                    <div
                      className={
                        children ==
                        // "Annual Report" ? "sidebarActive"
                        "commonLink"
                      }
                      id="new_report_div"
                      onClick={(e) => {
                        e.preventDefault();
                        openIncomeDeclarationLink();
                      }}
                    >
                      <div className="icon">{routes[7].icon}</div>

                      <div className="menu-names-link">
                        {isOpen && <div>{routes[7].name}</div>}
                      </div>
                    </div>
                  ))}
              </>
            )}
            {/*Annual Report */}
            {routes[1].subRoutes ? (
              <SidebarMenu
                setIsOpen={setIsOpen}
                route={routes}
                showAnimation={showAnimation}
                isOpen={isOpen}
              />
            ) : (
              <NavLink
                to={routes[1].path}
                className={
                  children == "Annual Report" ? "sidebarActive" : "commonLink"
                }
                activeClassName="active"
                onClick={(e) => sideMenuOnClick(e, routes[1].name)}
              >
                <div className="icon">{routes[1].icon}</div>
                <div className="menu-names-link">
                  {isOpen && (
                    <div>
                      {userSelectedLanguage == "sw"
                        ? routes[1].swName
                        : routes[1].name}
                    </div>
                  )}
                </div>
              </NavLink>
            )}
            {/*Income Declaration-2 */}
            {incomeButtonVisible &&
              (routes[2].subRoutes ? (
                <SidebarMenu
                  setIsOpen={setIsOpen}
                  route={routes}
                  showAnimation={showAnimation}
                  isOpen={isOpen}
                />
              ) : (
                <NavLink
                  to={routes[2].path}
                  className={
                    children == "Income Declaration 2"
                      ? "sidebarActive"
                      : "commonLink"
                  }
                  activeClassName="active"
                  onClick={(e) => sideMenuOnClick(e, routes[2].name)}
                >
                  <div className="icon">
                    {routes[2].icon}
                    {sideBarReducerValues &&
                      sideBarReducerValues.includes("Profile / Packages") && (
                        <FcApproval className="tickIcon" />
                      )}
                  </div>
                  <div className="menu-names-link">
                    {isOpen && (
                      <div>
                        {userSelectedLanguage == "sw"
                          ? routes[2].swName
                          : routes[2].name}
                      </div>
                    )}
                  </div>
                </NavLink>
              ))}
            {/* Profile / Packages */}
            {routes[3].subRoutes ? (
              <SidebarMenu
                setIsOpen={setIsOpen}
                route={routes}
                showAnimation={showAnimation}
                isOpen={isOpen}
              />
            ) : (
              <NavLink
                to={routes[3].path}
                className={
                  children == "Profile / Packages"
                    ? "sidebarActive"
                    : "commonLink"
                }
                activeClassName="active"
                onClick={(e) => sideMenuOnClick(e, routes[3].name)}
              >
                <div className="icon">
                  {routes[3].icon}
                  {sideBarReducerValues &&
                    sideBarReducerValues.includes("Profile / Packages") && (
                      <FcApproval className="tickIcon" />
                    )}
                </div>
                <div className="menu-names-link">
                  {isOpen && (
                    <div>
                      {userSelectedLanguage == "sw"
                        ? routes[3].swName
                        : routes[3].name}
                    </div>
                  )}
                </div>
              </NavLink>
            )}
            {/* Admin*/}
            {showAdmin && (
              <div>
                {routes[4].subRoutes ? (
                  <SidebarMenu
                    setIsOpen={setIsOpen}
                    route={routes}
                    showAnimation={showAnimation}
                    isOpen={isOpen}
                  />
                ) : (
                  <NavLink
                    to={routes[4].path}
                    // to={`/${userGUID}/admin`}
                    className={
                      children == "Manage Company Users"
                        ? "sidebarActive"
                        : "commonLink"
                    }
                    activeClassName="active"
                    style={{
                      backgroundColor: isInDashboardPage ? "#E1E1E7" : ""
                    }}
                    onClick={(e) => sideMenuOnClick(e, routes[4].name)}
                  >
                    <div className="icon">
                      {routes[4].icon}{" "}
                      {sideBarReducerValues.includes("Admin") && (
                        <FcApproval className="tickIcon" />
                      )}
                    </div>
                    <div
                      className="menu-names-link"
                      style={{
                        color: isInDashboardPage ? "gray" : ""
                      }}
                    >
                      {isOpen && (
                        <div>
                          {userSelectedLanguage == "sw"
                            ? routes[4].swName
                            : routes[4].name}
                        </div>
                      )}
                    </div>
                  </NavLink>
                )}
              </div>
            )}
            {/* Logout */}
            {routes[5].subRoutes ? (
              <SidebarMenu
                setIsOpen={setIsOpen}
                route={routes}
                showAnimation={showAnimation}
                isOpen={isOpen}
              />
            ) : (
              <NavLink
                to={routes[5].path}
                className={
                  children == "Logout" ? "sidebarActive" : "commonLink"
                }
                activeClassName="active"
                style={{
                  backgroundColor: isInDashboardPage ? "#E1E1E7" : ""
                }}
                onClick={(e) => sideMenuOnClick(e, routes[5].name)}
              >
                <div className="icon">
                  {routes[5].icon}
                  {sideBarReducerValues.includes("Logout") && (
                    <FcApproval className="tickIcon" />
                  )}
                </div>

                <div className="menu-names-link">
                  {isOpen && (
                    <div>
                      {userSelectedLanguage == "sw"
                        ? routes[5].swName
                        : routes[5].name}
                    </div>
                  )}
                </div>
              </NavLink>
            )}
          </section>
        </motion.div>
      </div>

      <div onClick={(event) => sideMenuOnClick(event)}>
        <Dialog
          visible={openDialog}
          onHide={() => setOpenDialog(false)}
          footer={dialogFooter}
          className="dashbaordSideBarSignOutDialogBox"
        >
          <p>
            <i className="pi pi-sign-out" style={{ marginRight: "1em" }}></i>

            {
              TranslationFile.signoutFromMyProfileSidebarQuestion[
                userSelectedLanguage
              ]
            }
          </p>
        </Dialog>
      </div>
    </div>
  );
};

export default Sidebar;
